import React from 'react';

const WinnerSelection = ({openAnimation, isSoundOn, volume, setVolume}) => {

    const startSelectionClickSound = () => {
        const audio_start_selection_click = new Audio('sound/button_sound/Start_Sel_BTN.ogg');
        audio_start_selection_click.volume = volume / 100;
        audio_start_selection_click.play();
    }

    return (
      <div>
        <button className="common-but start-select-but" onClick={() => { openAnimation(); isSoundOn && startSelectionClickSound(); }}>Start selection</button>
      </div>
    );
};

export default WinnerSelection;
